import {AfterViewInit, Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {HomePageService} from '../home-page/home-page.service';
import {AppService} from '../app.service';
import SwiperCore, {Thumbs, EffectFade, Navigation, Pagination, Scrollbar, Swiper, Autoplay} from 'swiper';

SwiperCore.use([Thumbs, EffectFade, Scrollbar, Navigation, Pagination, Swiper, Autoplay]);

@Component({
  selector: 'app-home-page-finish',
  templateUrl: './home-page-finish.component.html',
  styleUrls: ['./home-page-finish.component.scss']
})
export class HomePageFinishComponent implements OnInit, AfterViewInit, OnDestroy {
    private screenWidth = window.innerWidth;
    private sectionToNavigateSubscription: Subscription;
    private preloadLinks: HTMLLinkElement[] = [];
    showTestDrive = false;
    showNewsletter = false;
    galleryLeft: Swiper;
    galleryThumbs: Swiper;
    private textSectionObserver?: IntersectionObserver;
    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.screenWidth = event.target.innerWidth;
        this.checkWidth();
        // if (this.screenWidth < 993) {
        // SwiperCore.use([Navigation, Pagination, Scrollbar, EffectFade, Swiper]);

        // }
        this.updateSwipers();
    }

    constructor(
        public homePageService: HomePageService,
        private appService: AppService
    ) {
        this.homePageService.isHomePage = true;
    }

    showForm() {
        const link = window.location.href;
        const testDrive = /jazda-probna/;
        const newsletter = /newsletter/;
        if (testDrive.test(link)) {
            setTimeout(() => {
                this.showTestDrive = true;
            }, 100);
        }
        if (newsletter.test(link)) {
            setTimeout(() => {
                this.showNewsletter = true;
            }, 100);
        }
    }

    closeModal() {
        const modalFinish = document.getElementById('modalFinish');
        modalFinish.style.display = 'none';
    }

    ngOnInit() {
        this.checkWidth();
        if (!this.homePageService.isMobileDevice) {
            this.addPreloadLink('./assets/images/vid/30_rps_nauczyciel_final_2026.mp4', 'video', 'video/mp4');
        }
        if (this.screenWidth < 993) {
            SwiperCore.use([Navigation, Pagination, Scrollbar, EffectFade, Swiper]);
        }
    }

    ngAfterViewInit() {
        this.showForm();
        this.initObbiSlider();
        setTimeout(() => this.updateSwipers(), 0);
        this.initText2DecorAnimation();
    }

    ngOnDestroy() {
        this.sectionToNavigateSubscription?.unsubscribe();
        this.textSectionObserver?.disconnect();
        this.removePreloadLinks();
    }

    private addPreloadLink(href: string, as: 'video' | 'image', type?: string) {
        const link = document.createElement('link');
        link.rel = 'preload';
        link.as = as;
        link.href = href;
        if (type) {
            link.type = type;
        }
        document.head.appendChild(link);
        this.preloadLinks.push(link);
    }

    private removePreloadLinks() {
        this.preloadLinks.forEach((link) => link.remove());
        this.preloadLinks = [];
    }

    private initText2DecorAnimation() {
        const text2Section = document.getElementById('text2');
        if (!text2Section) {
            return;
        }

        if (typeof IntersectionObserver === 'undefined') {
            text2Section.classList.add('is-in-view');
            return;
        }

        this.textSectionObserver = new IntersectionObserver(([entry]) => {
            if (entry?.isIntersecting) {
                text2Section.classList.add('is-in-view');
            }
        }, {
            threshold: 0.12,
            rootMargin: '0px 0px -5% 0px'
        });
        this.textSectionObserver.observe(text2Section);
    }

    private checkWidth() {
        this.homePageService.isMobileDevice = this.screenWidth < 768;
    }

    private initObbiSlider() {
        const thumbsElement = document.querySelector('#obbi-slider-wrapper .gallery-thumbs');
        const leftElement = document.querySelector('#obbi-slider-wrapper .gallery-left');
        if (!leftElement) {
            return;
        }

        this.galleryThumbs = new Swiper('#obbi-slider-wrapper .gallery-thumbs', {
            // spaceBetween: 18,
            slidesPerView: 4,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            direction: 'vertical',
            allowTouchMove: false,
        });

        const swiperOptionsLeft: any = {
            spaceBetween: 10,
            slidesPerView: 1.2,
            slidesOffsetAfter: 30,
            // loop: true,
            breakpoints: {
                991: {
                    slidesPerView: 'auto',
                    // spaceBetween: 24,
                    // slidesOffsetAfter: 20,
                }
            },
            thumbs: {
                swiper: this.screenWidth >= 991 && thumbsElement ? this.galleryThumbs : null,
            }
        };

        if (this.screenWidth < 991) {
            swiperOptionsLeft.navigation = {
                nextEl: '#obbi-slider-wrapper .swiper-button-next',
                prevEl: '#obbi-slider-wrapper .swiper-button-prev',
            };
            swiperOptionsLeft.pagination = {
                el: '#obbi-slider-wrapper .swiper-pagination',
                clickable: true,
            };
        }

        this.galleryLeft = new Swiper('#obbi-slider-wrapper .gallery-left', swiperOptionsLeft);
    }
    private updateSwipers() {
        if (this.galleryLeft && !(this.galleryLeft as any).destroyed) {
            try {
                this.galleryLeft.update();
            } catch {
                // Swiper can throw before slides are fully mounted.
            }
        }
        if (this.galleryThumbs && !(this.galleryThumbs as any).destroyed) {
            try {
                this.galleryThumbs.update();
            } catch {
                // Swiper can throw before slides are fully mounted.
            }
        }
    }


    goDown1() {
        // this.scroller.scrollToAnchor('annotation1');
        const input = document.getElementById('annotation1');
        if (input !== null) {
            const offsetTopMargin = 70;
            window.scroll({
                top: input.offsetTop - offsetTopMargin,
                behavior: 'smooth',
            });
        }
    }
    goDown2() {
        // this.scroller.scrollToAnchor('annotation2');
        const input = document.getElementById('annotation2');
        if (input !== null) {
            const offsetTopMargin = 70;
            window.scroll({
                top: input.offsetTop - offsetTopMargin,
                behavior: 'smooth',
            });
        }
    }
    goDown3() {
        // this.scroller.scrollToAnchor('annotation3');
        const input = document.getElementById('annotation3');
        if (input !== null) {
            const offsetTopMargin = 70;
            window.scroll({
                top: input.offsetTop - offsetTopMargin,
                behavior: 'smooth',
            });
        }
    }
    goDown4() {
        // this.scroller.scrollToAnchor('annotation3');
        const input = document.getElementById('annotation4');
        if (input !== null) {
            const offsetTopMargin = 70;
            window.scroll({
                top: input.offsetTop - offsetTopMargin,
                behavior: 'smooth',
            });
        }
    }

    scrollToform() {
        // const input = document.getElementById('inputFormOffer');
        // input.scrollIntoView({ behavior: "smooth", block: "start" });
        const input = document.getElementById('inputFormOffer');
        if (input !== null) {
            const offsetTopMargin = 70;
            window.scroll({
                top: input.offsetTop - offsetTopMargin,
                behavior: 'smooth',
            });
        }
    }

    scrollToform2() {
        // const input = document.getElementById('sectionOfferForm');
        // input.scrollIntoView({ behavior: "smooth", block: "start" })
        const input = document.getElementById('sectionOfferForm');
        if (input !== null) {
            const offsetTopMargin = 70;
            window.scroll({
                top: input.offsetTop - offsetTopMargin,
                behavior: 'smooth',
            });
        }
    }

    scrollToRaceSection() {
        const input = document.getElementById('sectionRace');
        if (input !== null) {
            const offsetTopMargin = 70;
            window.scroll({
              top: input.offsetTop - offsetTopMargin,
              behavior: 'smooth',
          });
        }
    }

    scrollToDescriptionSection() {
        const input = document.getElementById('discover');
        if (input !== null) {
            // const offsetTopMargin = 70;
            window.scroll({
                top: input.offsetTop,
                behavior: 'smooth',
            });
        }
    }

    scrollToEquipmentSection() {
        if (this.screenWidth < 993) {
            // const input = document.getElementById('sectionChange1');
            // input.scrollIntoView({ behavior: "smooth", block: "start" });
            const input = document.getElementById('sectionEquipmentMobile');
            if (input !== null) {
                const offsetTopMargin = 200;
                window.scroll({
                    top: input.offsetTop - offsetTopMargin,
                    behavior: 'smooth',
                });
            }
        } else if (this.screenWidth > 994 && this.screenWidth < 1920) {
            // const input = document.getElementById('sectionEquipmentDesktop');
            // input.scrollIntoView({ behavior: "smooth", block: "start" });
            const input = document.getElementById('sectionEquipmentDesktop');
            if (input !== null) {
                const offsetTopMargin = 250;
                window.scroll({
                    top: input.offsetTop - offsetTopMargin,
                    behavior: 'smooth',
                });
            }
        } else {
            // const input = document.getElementById('sectionEquipmentDesktop');
            // input.scrollIntoView({ behavior: "smooth", block: "start" });
            const input = document.getElementById('sectionEquipmentDesktop');
            if (input !== null) {
                const offsetTopMargin = 330;
                window.scroll({
                    top: input.offsetTop - offsetTopMargin,
                    behavior: 'smooth',
                });
            }
        }
    }

    sendGaEvent(event, eventLabel, eventCategory) {
        this.appService.sendGaData(event, eventLabel, eventCategory);
    }

}

